export default __webpack_public_path__ + "static/media/Mc001-Picture2.433e46d2.png";